import { createContent, deleteContent, getContents, updateContent } from "../../api/content";
import { toArray, toObject } from "../../utils/languageContent";
import moment from "moment";
import Vue from "vue";
import _ from "lodash";
import { PERMISSION_TYPES } from "../../language/permissionTypes";
import { checkPermission } from "../../utils/PermissionUtils";
import log2 from "../../utils/log2";

const log = log2("vuex.content");
const content = {
    namespaced: true,
    state: {
        contents: {
            count: 0,
            data: [],
            total: 0,
        },
    },
    getters: {
        getGrouped(state) {
            const contents = state.contents.data;
            const parents = contents.filter((c) => c.parentId === null);
            //parentId si var fakat o parentId'de kimse yoksa bunlarda kendi başına bir parent olarak kabul ediliyor
            const maybeOtherParents = _.difference(contents, parents).filter(
                (item) => contents.filter((x) => x._id === item.parentId).length === 0
            );

            maybeOtherParents.forEach((x) => {
                x.parentId = null;
            });
            const allParents = [...parents, ...maybeOtherParents];
            allParents.forEach((p, k) => {
                allParents[k].children = contents.filter((c) => c.parentId === p._id) || [];
            });

            return _.sortBy(allParents, (q) => q["order"] || moment(q.createdAt).valueOf());
        },
    },
    mutations: {
        SET_CONTENTS: (state, payload) => {
            state.contents = payload;
        },
        ADD_CONTENT: (state, payload) => {
            state.contents.data.push(payload);
            state.contents.total++;
        },
        UPDATE_CONTENT: (state, payload) => {
            let index = state.contents.data.findIndex((p) => p._id === payload._id);
            Vue.set(state.contents.data, index, {
                ...state.contents.data[index],
                ...payload,
            });
        },
        UPDATE_PARENT: (state, { _id, parentId }) => {
            let index = state.contents.data.findIndex((p) => p._id === _id);
            state.contents.data[index].parentId = parentId;
        },
        DELETE_CONTENT: (state, id) => {
            state.contents.data = state.contents.data.filter((r) => r._id !== id);
            state.contents.total--;
        },
    },
    actions: {
        getContents({ commit, rootState }, payload) {
            return getContents(payload.perPage, payload.page).then((response) => {
                commit("SET_CONTENTS", {
                    data: response.data.data.map((x) => toObject(x)),
                    count: response.data.count,
                    total: response.data.total,
                });
                return response.data;
            });
        },
        getContent({ state }, id) {
            return state.contents.data.find((p) => p._id === id);
        },
        createContent({ commit }, payload) {
            return createContent(toArray(payload)).then((response) => {
                commit("ADD_CONTENT", toObject(response.data));
            });
        },
        updateContent({ commit }, payload) {
            return updateContent(payload._id, toArray(payload)).then((response) => {
                commit("UPDATE_CONTENT", toObject(response.data));
            });
        },
        contentUpdated({ commit }, content) {
            commit("UPDATE_CONTENT", content);
        },
        deleteContent({ commit }, { id, sendToBackEnd = true }) {
            if (sendToBackEnd) {
                return deleteContent(id).then((response) => {
                    commit("DELETE_CONTENT", id);
                    return Promise.resolve(response);
                });
            } else {
                commit("DELETE_CONTENT", id);
                return Promise.resolve();
            }
        },
        updateParent({ state, commit }, payload) {
            commit("UPDATE_PARENT", payload);
            const content = state.contents.data.find((c) => c._id === payload._id);
            content
                ? updateContent(payload._id, toArray(content)).then((response) => {
                      commit("UPDATE_CONTENT", toObject(response.data));
                  })
                : Promise.reject("Content not found");
        },
    },
};

export default content;
